import { render } from "./inspirational-carousel.vue?vue&type=template&id=0fd9caf0"
import script from "./inspirational-carousel.vue?vue&type=script&lang=js"
export * from "./inspirational-carousel.vue?vue&type=script&lang=js"

import "./inspirational-carousel.vue?vue&type=style&index=0&id=0fd9caf0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__